import { useQuery } from "@tanstack/react-query";
import { downloadNewMembershipEnrollmentReport } from "../../service/query/auth";

export const useDownloadNewMembershipReport = ({ payload}) => {
  const newMembersEnrollementReport= useQuery({
    queryKey: ['NewMembershipEnrollmentForm', payload],
    queryFn: () => downloadNewMembershipEnrollmentReport({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  },
);
  return {data:newMembersEnrollementReport?.data?.data,  ...newMembersEnrollementReport,}
};